import { MdDelete } from "react-icons/md";
import "../../styles/cart.css";

export default function AddressList({
  title = "Select Address",
  customerAddressList,
  selectedCustomerAddressId,
  handleSelectAddress,
  handleDeleteAddress,
  handleAddAddress,
  showDeleteButton = true,
}) {
  return (
    <div className="address-section">
      <h2 className="section-title">{title}</h2>
      {customerAddressList.length > 0 ? (
        <div className="address-list">
          {customerAddressList.map((address, index) => (
            <div
              className="address-item"
              key={index}
              onClick={() => handleSelectAddress(address)}
              style={
                selectedCustomerAddressId === address.id
                  ? {
                      backgroundColor: "#fdf1ec",
                    }
                  : {}
              }
            >
              <div>
                <input
                  type="radio"
                  name="address"
                  id={`address-${index}`}
                  checked={selectedCustomerAddressId === address.id} // Check if this address is selected
                  onChange={() => handleSelectAddress(address)} // Update selected address
                />
                <label
                  htmlFor={`address-${index}`}
                  style={{ marginLeft: "10px" }}
                >
                  {address.name} - {address.mobile}, {address.addressLine1} -{" "}
                  {address.city}
                </label>
              </div>
              {showDeleteButton && (
                <div>
                  <MdDelete
                    onClick={() => handleDeleteAddress(address.id)} // Call delete function
                  />
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="no-address-message">
          No addresses saved. Add a new one below!
        </p>
      )}
      <button className="add-address-btn" onClick={handleAddAddress} type="button">
        Add New Address
      </button>
    </div>
  );
}
